import { defineComponent } from 'vue';
import MessageBoxPlain from './MessageBoxPlain.vue';
import Icon from '../Icon.vue';
export default defineComponent({
    name: 'MessageBoxWithIcon',
    components: { MessageBoxPlain, Icon },
    compatConfig: {
        MODE: 3,
    },
    extends: MessageBoxPlain,
    props: {
        ...MessageBoxPlain.props,
        iconName: {
            type: String,
            required: true,
        },
        iconTitle: {
            type: String,
            required: true,
        },
    },
});
